const pms_occupancy_at_closing = [
  {
    value: "vacant",
    name: "Vacant",
  },
  {
    value: "rented",
    name: "Rented",
  },
  {
    value: "eviction",
    name: "Non Paying Tenant (eviction needed)",
  },
  {
    value: "owner_occupied",
    name: "Owner Occupied",
  },
];

export default pms_occupancy_at_closing;



// WEBPACK FOOTER //
// ./src/constants/pms_occupancy_at_closing.js